// Full-document render of the pillows UtilityPage: PageSkeleton (the React
// document shell) wrapping the utility-page layout.
import React from "react";
import { jt } from "ttag";

import { templates } from "@reactivated";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import { PageSkeleton } from "../components/PageSkeleton";
import { SideNav } from "../components/SideNav";
import { UtilityPageBody } from "../components/UtilityPageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton). The reused body component accepts the
// deeply-readonly StreamField body either way.
export const Template = (
    props: templates.UtilityPageTemplate,
): React.JSX.Element => {
    const {
        page,
        has_nav,
        side_nav,
        has_right_bar,
        right_bar,
        content_title,
        phone_display,
        phone_href,
    } = props;
    // ttag's `jt` forbids a conditional/logical expression directly inside the
    // `${...}` interpolation, so compute the optional phone link first.
    const phoneLink = phone_display ? (
        <a key="phone" href={phone_href}>
            {phone_display}
        </a>
    ) : null;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
                {has_nav && (
                    <div className="l-side-nav">
                        <SideNav items={side_nav} selfManaged={true} />
                    </div>
                )}

                <div className="l-side-nav-content">
                    <div className="content-title">
                        <h1 className="content-title__headline">
                            {content_title}
                        </h1>
                        <span className="content-title__info">
                            {jt`Talk to Sleep Expert ${phoneLink}`}
                        </span>
                    </div>

                    <div
                        className={
                            has_right_bar
                                ? "content__copy"
                                : "content__copy--full-width"
                        }
                    >
                        {page.body ? (
                            <UtilityPageBody value={page.body.value} />
                        ) : null}
                    </div>

                    {has_right_bar && (
                        <aside className="content__aside">
                            {right_bar.map((item, i) =>
                                // Each block wrapped `w-block-{type} block-{type}`
                                // to match the `{{ page.right_bar }}` StreamField
                                // render.
                                item.block_type === "right_bar_section" ? (
                                    <div
                                        key={i}
                                        className={`w-block-${item.block_type} block-${item.block_type}`}
                                    >
                                        <h1 className="content__aside__title">
                                            {item.header}
                                        </h1>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: item.body_html,
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <EditorContent key={i}>
                                        {(marker) => (
                                            <div
                                                className={`w-block-${item.block_type} block-${item.block_type}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: item.body_html,
                                                }}
                                                {...marker}
                                            />
                                        )}
                                    </EditorContent>
                                ),
                            )}
                        </aside>
                    )}
                </div>
            </div>
        </PageSkeleton>
    );
};
